import { combineReducers } from "redux";

import { toastReducers } from "./slices/toastSlice";

// RTK Query API slice

import { authApiAction, authApiReducer } from "./apiSlices/authApiSlice";
import { ordersApiAction, OrdersApiReducer } from "./apiSlices/orderApi/orderApiSlice";
import { ClientsApiReducer,clientsApiAction } from "./apiSlices/clientApi/clientApiSlice";
import { productsApiAction, ProductsApiReducer } from "./apiSlices/productApi/productApiSlice";
import { driversApiAction ,DriversApiReducer} from "./apiSlices/driverApi/driverApiSlice";



const rootReducers = combineReducers({
	toast: toastReducers,
	[authApiAction.reducerPath]: authApiReducer,
	[ordersApiAction.reducerPath]:OrdersApiReducer,
	[clientsApiAction.reducerPath]:ClientsApiReducer,
	[productsApiAction.reducerPath]:ProductsApiReducer,
	[driversApiAction.reducerPath]:DriversApiReducer,
	
});

export default rootReducers;
